import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isAuthenticated } from "./api";

const ProtectedRoute = ({ children }) => {
    const authed = isAuthenticated();

    // When the session is invalid (no auth flag or an expired token), purge any
    // stale data left in localStorage so it can't drive a redirect loop.
    React.useEffect(() => {
        if (!authed) {
            localStorage.clear();
        }
    }, [authed]);

    if (authed) {
        return children ? children : <Outlet />;
    }

    return <Navigate to="/login" replace />;
};

export default ProtectedRoute;



